export const isPageNotFoundError = (obj: unknown): obj is Error =>
	obj instanceof Error && obj.name === 'PageNotFoundError';

export const isError = (obj: unknown): obj is Error => obj instanceof Error;
